export default __webpack_public_path__ + "static/media/screenshot2_sm.7ed1233d.jpg";